module.exports = __webpack_public_path__ + "9f4e64918eb419c78311ac7c1f7ba4d3.MP3";